<template>
    <div class="font_body" v-html="content">

    </div>
</template>

<script>
    export default {
        name: "Ggzw",
        props: ["content"]
    }
</script>

<style scoped>
    .font_body {
        font-size: 14px;
        line-height: 1.42857143;
        color: #333;
        background-color: #fff;
        margin: 0 auto;
    }
</style>